import {
  AlertCircle,
  Block,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import {
  selectRepayStrategy,
  selectWalletBalances,
  setRepayStrategy,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { useDebtAmountWithoutFees } from "#/shared/hooks"
import { BorrowRepayStrategy } from "#/shared/types"
import { bigIntToHumanReadableFormat } from "#/shared/utils"

import BorrowStrategyItem from "../components/BorrowStrategyItem"

export default function RepayActionStrategy() {
  const [css, theme] = useStyletron()
  const dispatch = useDappDispatch()
  const { MUSD } = useDappSelector(selectWalletBalances)

  const repayStrategy = useDappSelector(selectRepayStrategy)

  const { debtAmountWithoutGasComp, debtAmountWithoutGasCompLabel } =
    useDebtAmountWithoutFees()

  const hasEnoughBalance = MUSD.balance >= debtAmountWithoutGasComp

  const balanceNeeded = debtAmountWithoutGasComp - MUSD.balance

  const debtFullPrecision = bigIntToHumanReadableFormat(
    debtAmountWithoutGasComp,
    18,
    18,
  )

  return (
    <Block>
      <BorrowStrategyItem
        isDisabled={!hasEnoughBalance}
        onChange={() => dispatch(setRepayStrategy(BorrowRepayStrategy.TOTAL))}
        isChecked={repayStrategy === BorrowRepayStrategy.TOTAL}
        title="Total repayment"
        description={
          <ParagraphSmall
            color={theme.colors.contentSecondary}
            title={`Total debt: ${debtFullPrecision} MUSD`}
          >
            {debtAmountWithoutGasCompLabel} MUSD
          </ParagraphSmall>
        }
        status={
          hasEnoughBalance || (
            <Block
              className={css({
                display: "flex",
                alignItems: "center",
                gap: theme.sizing.scale100,
                marginTop: theme.sizing.scale300,
              })}
            >
              <AlertCircle size={14} color={theme.colors.contentNegative} />
              <ParagraphSmall color={theme.colors.contentNegative}>
                Insufficient funds. You need{" "}
                {bigIntToHumanReadableFormat(balanceNeeded, 18, 18)} MUSD more.
              </ParagraphSmall>
            </Block>
          )
        }
      />
      <BorrowStrategyItem
        onChange={() => dispatch(setRepayStrategy(BorrowRepayStrategy.PARTIAL))}
        isChecked={repayStrategy === BorrowRepayStrategy.PARTIAL}
        title="Partial repayment"
        description={
          <ParagraphSmall color={theme.colors.contentSecondary}>
            Input custom amount
          </ParagraphSmall>
        }
      />
    </Block>
  )
}
